import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import "./landing/landing.css";

import { API } from "@/apiBase";
const ink = "#0a1e38", inkSoft = "#5a7088", clay = "#1e7be5";
const serif = { fontFamily: '"Fraunces",Georgia,serif', fontWeight: 500 };
const wrap = { fontFamily: '"Hanken Grotesk",system-ui,sans-serif', color: ink, minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 };
const card = { background: "#fff", border: "1px solid rgba(10,30,56,.13)", borderRadius: 24, padding: "44px 38px", maxWidth: 480, textAlign: "center", boxShadow: "0 40px 90px -40px rgba(10,30,56,.5)" };
const homeBtn = { display: "inline-flex", marginTop: 22, padding: "12px 26px", borderRadius: 100, background: ink, color: "#fff", textDecoration: "none", fontWeight: 600 };

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("polling"); // polling | paid | pending | error

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0, active = true;
    const poll = async () => {
      if (!active) return;
      try {
        const res = await fetch(`${API}/payments/status/${sessionId}`);
        const data = await res.json();
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) { /* keep trying */ }
      tries += 1;
      if (tries >= 8) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div style={wrap}>
      <div style={card}>
        {state === "polling" && (<><Loader2 size={48} color={clay} style={{ animation: "spin 1s linear infinite" }} /><h1 style={{ ...serif, fontSize: "1.6rem", marginTop: 18 }}>Confirming your payment…</h1><p style={{ color: inkSoft, marginTop: 8 }}>One moment while we check with Stripe.</p><style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style></>)}
        {state === "paid" && (<><CheckCircle2 size={54} color="#12a37f" /><h1 style={{ ...serif, fontSize: "1.7rem", marginTop: 16 }}>You're booked in.</h1><p style={{ color: inkSoft, marginTop: 10 }}>Payment received — thank you. I'll confirm your session time by WhatsApp or email shortly.</p><Link data-testid="success-home-link" to="/" style={homeBtn}>Back to site</Link></>)}
        {state === "pending" && (<><Loader2 size={48} color={clay} /><h1 style={{ ...serif, fontSize: "1.6rem", marginTop: 16 }}>Almost there</h1><p style={{ color: inkSoft, marginTop: 10 }}>Your payment is processing. You'll get a confirmation shortly — no need to pay again.</p><Link to="/" style={homeBtn}>Back to site</Link></>)}
        {state === "error" && (<><XCircle size={54} color="#c0392b" /><h1 style={{ ...serif, fontSize: "1.6rem", marginTop: 16 }}>We couldn't confirm this</h1><p style={{ color: inkSoft, marginTop: 10 }}>If you were charged, don't worry — reach out and I'll sort it. Otherwise you can try booking again.</p><Link to="/" style={homeBtn}>Back to site</Link></>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div style={wrap}>
      <div style={card}>
        <XCircle size={54} color={inkSoft} />
        <h1 style={{ ...serif, fontSize: "1.7rem", marginTop: 16 }}>Checkout cancelled</h1>
        <p style={{ color: inkSoft, marginTop: 10 }}>No payment was taken. Whenever you're ready, you can pick a plan and book again.</p>
        <Link data-testid="cancel-home-link" to="/" style={homeBtn}>Back to site</Link>
      </div>
    </div>
  );
}
